// extracted by mini-css-extract-plugin
export default {"content":"Report_content__MtNiR"};